class pgweb.Event
	@on: (events, handler) ->
		$('html').on events, 'body', handler

	@trigger: (event, params) ->
		$('body').trigger event, JSON.stringify params
